import { Inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LOADING_SERVICE, LoadingService } from '../services/loading.service';
import { finalize } from 'rxjs/operators';

export const SKIP_LIST = [
  'keepAlive'
];

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(@Inject(LOADING_SERVICE) private readonly loadingService: LoadingService) {
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (this.isAvailable(req?.url)) {
      this.loadingService.increment();
      return next.handle(req).pipe(
        finalize(() => {
          this.loadingService.decrement();
        })
      );
    } else {
      return next.handle(req);
    }
  }

  /**
   * Checks if the URL is available for the loading indicator
   * @param url Request URL
   */
  isAvailable(url: string): boolean {
    return SKIP_LIST.reduce((carry, key) => {
      return carry && !url.endsWith(key);
    }, true);
  }
}
